<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <h3>执行看板</h3>
      <el-select v-model="selectedWaveId" placeholder="选择波次" size="small" @change="loadDealers" style="width: 240px;">
        <el-option v-for="w in waveList" :key="w.Id || w.id" :label="w.Name || w.name" :value="w.Id || w.id"></el-option>
      </el-select>
    </div>

    <!-- 统计卡片 -->
    <div class="stat-cards" v-if="currentWave">
      <div class="stat-card">
        <div class="stat-number">{{ currentWave.DealerCount || 0 }}</div>
        <div class="stat-label">门店总数</div>
      </div>
      <div class="stat-card warning">
        <div class="stat-number">{{ currentWave.ReviewPending || 0 }}</div>
        <div class="stat-label">待审核</div>
      </div>
      <div class="stat-card primary">
        <div class="stat-number">{{ currentWave.Review1 || 0 }}</div>
        <div class="stat-label">一审完成</div>
      </div>
      <div class="stat-card">
        <div class="stat-number">{{ currentWave.Review2 || 0 }}</div>
        <div class="stat-label">二审完成</div>
      </div>
      <div class="stat-card success">
        <div class="stat-number">{{ currentWave.Review3 || 0 }}</div>
        <div class="stat-label">三审完成</div>
      </div>
      <div class="stat-card danger">
        <div class="stat-number">{{ rejectedCount }}</div>
        <div class="stat-label">已驳回</div>
      </div>
    </div>

    <!-- 经销商明细 -->
    <div class="table-card" style="margin-top: 16px;">
      <el-table :data="dealerList" v-loading="loading" class="proto-table">
        <el-table-column label="门店信息" min-width="250">
          <template slot-scope="{ row }">
            <div class="name-cell">
              <div class="icon-box blue"><i class="el-icon-office-building"></i></div>
              <div>
                <div class="row-title">{{ row.DealerName || row.dealerName }}</div>
                <div class="row-sub">{{ row.DealerCode || row.dealerCode }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="神客" width="120">
          <template slot-scope="{ row }">
            <span style="color: #6b7280;">{{ row.ShopperName || row.shopperName || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="130" align="center">
          <template slot-scope="{ row }">
            <span class="status-badge" :class="getDealerStatusClass(row)">
              <span class="dot"></span>{{ getDealerStatusText(row) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="goGrading(row)" :disabled="!(row.Status || row.status)">
              <i class="el-icon-s-check"></i> 审核
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getWaveList, getWaveDealers } from 'index/api/project/wave'

export default {
  name: 'ProjectDashboard',
  data() {
    return { waveList: [], dealerList: [], selectedWaveId: null, loading: false }
  },
  computed: {
    projectId() { return this.$route.params.projectId },
    currentWave() {
      if (!this.selectedWaveId) return null
      return this.waveList.find(w => (w.Id || w.id) === this.selectedWaveId)
    },
    rejectedCount() {
      return this.dealerList.filter(d => (d.Status || d.status) === -1 || (d.AuditStatus || d.auditStatus) === -1).length
    }
  },
  mounted() { this.loadWaves() },
  methods: {
    getDealerStatusClass(row) {
      if ((row.Status || row.status) === -1 || (row.AuditStatus || row.auditStatus) === -1) return 'danger'
      if ((row.Status || row.status) === 2) return 'success'
      if (row.QrcodeUrl || row.qrcodeUrl) return 'warning'
      return 'info'
    },
    getDealerStatusText(row) {
      if ((row.Status || row.status) === -1 || (row.AuditStatus || row.auditStatus) === -1) return '已驳回'
      if ((row.Status || row.status) === 2) return '已完成'
      if (row.QrcodeUrl || row.qrcodeUrl) return '进行中'
      return '待开始'
    },
    async loadWaves() {
      try {
        const res = await getWaveList(this.projectId)
        const data = res?.data?.data || res?.data || {}
        this.waveList = data.Rows || data.rows || data.records || []
        if (this.waveList.length > 0) {
          this.selectedWaveId = this.waveList[0].Id || this.waveList[0].id
          this.loadDealers()
        }
      } catch (e) {
        const data = e?.data?.data || e?.data || {}
        const rows = data.Rows || data.rows || []
        if (rows.length > 0) {
          this.waveList = rows
          this.selectedWaveId = rows[0].Id || rows[0].id
          this.loadDealers()
        }
      }
    },
    async loadDealers() {
      if (!this.selectedWaveId) return
      this.loading = true
      try {
        const res = await getWaveDealers(this.selectedWaveId)
        const data = res?.data?.data || res?.data || {}
        this.dealerList = data.Rows || data.rows || data || []
      } catch (e) { console.error('[Dashboard] Load dealers failed', e) }
      this.loading = false
    },
    goGrading(row) {
      const wave = this.currentWave
      const phases = wave?.Phases || wave?.phases || []
      const firstPhase = phases[0]
      const formKey = firstPhase?.formKey || firstPhase?.formId || ''
      if (!formKey) { this.$message.warning('该波次未配置问卷'); return }
      this.$router.push({ path: '/grading', query: { key: formKey, answerKey: row.answerKey || '' } })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-container { padding: 0; }
.dashboard-header {
  display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;
  h3 { margin: 0; font-size: 18px; font-weight: 500; }
}
.stat-cards { display: flex; gap: 16px; }
.stat-card {
  flex: 1; background: #fff; border-radius: 10px; padding: 16px; text-align: center;
  border: 1px solid #e5e7eb; box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06);
  .stat-number { font-size: 28px; font-weight: 600; color: #111827; }
  .stat-label { font-size: 13px; color: #6b7280; margin-top: 4px; }
  &.warning { .stat-number { color: #d97706; } }
  &.primary { .stat-number { color: #2563eb; } }
  &.success { .stat-number { color: #059669; } }
  &.danger { .stat-number { color: #dc2626; } }
}

/* el-table 样式覆盖 */
.table-card {
  border-radius: 12px; border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 1px 2px rgba(0,0,0,0.06);
  overflow: hidden;
}
.proto-table {
  &.el-table { border: none; }
  &::before, &::after { display: none; }
  ::v-deep  .el-table__header-wrapper th {
    background: rgba(249,250,251,0.8) !important;
    border-bottom: 1px solid #e5e7eb !important;
    font-size: 13px; font-weight: 500; color: #6b7280; padding: 14px 0;
    .cell { padding: 0 12px; }
  }
  ::v-deep  .el-table__body-wrapper {
    td { border-bottom: 1px solid #e5e7eb !important; font-size: 14px; color: #111827; padding: 14px 0; .cell { padding: 0 12px; } }
    tr:last-child td { border-bottom: none !important; }
    tr:hover > td { background: rgba(249,250,251,0.8) !important; }
  }
  ::v-deep  .el-table__body tr.hover-row > td { background: rgba(249,250,251,0.8) !important; }
}
.name-cell { display: flex; align-items: center; }
.icon-box {
  width: 40px; height: 40px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  margin-right: 16px; font-size: 20px; flex-shrink: 0;
  &.blue { background: #dbeafe; color: #2563eb; }
}
.row-title { font-size: 15px; font-weight: 700; color: #111827; line-height: 1.4; cursor: pointer; transition: color 0.15s; margin-bottom: 4px; }
::v-deep  .el-table__body tr:hover .row-title { color: #2563eb; }
.row-sub { font-size: 12px; color: #6b7280; }
.status-badge {
  display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 9999px; font-size: 12px; font-weight: 600;
  .dot { width: 6px; height: 6px; border-radius: 50%; margin-right: 6px; flex-shrink: 0; }
  &.success { background: #ecfdf5; color: #059669; border: 1px solid #a7f3d0; .dot { background: #10b981; } }
  &.warning { background: #fffbeb; color: #d97706; border: 1px solid #fde68a; .dot { background: #f59e0b; } }
  &.info    { background: #f3f4f6; color: #4b5563; border: 1px solid #e5e7eb; .dot { background: #9ca3af; } }
  &.danger  { background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; .dot { background: #ef4444; } }
}
</style>
